import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "MaterialManagementService",
  controller: "MaterialConfiguration",
};

const methods = [
    "AddMaterialConfigurationData",
    "UpdateMaterialConfigurationData",
    "DelMaterialConfigurationData",
    "GetMaterialConfigurationDataList",
    "GetAllMaterialCategory",
    "GetAllMaterialFileType",
    "GetMaterialConfigurationDataById"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
    Fun.prototype[path] = function(data) {
      return this.post(path, data);
    };
  });
};

const MaterialConfigurationResourcesApi = ZJApi.defineNewApi("MaterialConfigurationResourcesApi", factory);

export default MaterialConfigurationResourcesApi;
